const Phone = () => {

    // TIDIO & PHONE ICON STUFF
    (function() {
        function onTidioChatApiReady() {
            // Telephone badge status
            const day = new Date().getDay();
            const hour = new Date().getHours();
            // mon - fri between 9 AM and 5 PM respectively
            if((day >= 1 && day <= 5) && (hour >= 9 && hour < 17)) {
                var element = document.getElementById("telBadge-dot");
                element.classList.add("available");
            }
            // Pierce Tidio iFrame
            var element = document.getElementById("telBadge");
            var iframe = document.getElementById("tidio-chat-iframe");
            var parent = iframe.contentWindow.document.querySelector('html');
            var child = iframe.contentWindow.document.querySelector('.mobile');
            // Check if Tidio is in desktop or mobile mode
            if(parent) {
                if(child) {
                    if (parent.contains(child)) {
                        element.classList.add("mobile");
                    }
                }
            }
            var element = document.getElementById("telBadge");
            element.classList.add("visible");
        }
        if (window.tidioChatApi) {
            window.tidioChatApi.on("ready", onTidioChatApiReady);
        } else {
            document.addEventListener("tidioChat-ready", onTidioChatApiReady);
        }
    })();
    
}

export default Phone;